import React from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import {
  Droplets, SprayCan, Bug, GraduationCap, Truck, Thermometer, LayoutGrid, TriangleAlert, BookOpen, ChevronRight,
} from "lucide-react";
import Header from "@/components/Header";
import { Card } from "@/components/ui-kit";
import { listPlans } from "@/lib/api";

const PLAN_ICONS = {
  1: Droplets, 2: SprayCan, 3: Bug, 4: GraduationCap,
  5: Truck, 6: Thermometer, 7: LayoutGrid, 8: TriangleAlert,
};

export default function PlanList() {
  const { data: plans } = useSWR("appcc-plans", listPlans);

  return (
    <>
      <Header title="Plans APPCC" />
      <div className="mx-auto max-w-3xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
        <div className="animate-fade-up">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ink text-white"><BookOpen size={22} /></div>
            <div>
              <div className="label-eyebrow">Sistema d'autocontrol</div>
              <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl">Plans APPCC</h2>
            </div>
          </div>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-soft">
            Els 8 plans del sistema d'autocontrol: el document de cada pla, els seus registres i la documentació associada.
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {!plans && <Card className="text-center text-sm text-ink-soft">Carregant…</Card>}
          {plans?.length === 0 && <Card className="text-center text-sm text-ink-soft">Encara no hi ha plans carregats.</Card>}
          {plans?.map((p, idx) => {
            const Icon = PLAN_ICONS[p.number] || BookOpen;
            return (
              <Link key={p.number} to={`/plans/${p.number}`} data-testid={`plan-card-${p.number}`}
                className="group flex items-center gap-4 rounded-2xl border border-line bg-white p-5 shadow-card transition-all animate-fade-up hover:-translate-y-0.5 hover:shadow-soft"
                style={{ animationDelay: `${idx * 40}ms` }}>
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-muted text-ink">
                  <Icon size={24} />
                </div>
                <div className="flex-1">
                  <div className="label-eyebrow">Pla {p.number}</div>
                  <h3 className="mt-0.5 font-display text-lg font-bold leading-tight text-ink">{p.title}</h3>
                </div>
                <ChevronRight size={18} className="text-ink-soft transition-transform group-hover:translate-x-1" />
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}
